import { createFileRoute } from "@tanstack/react-router";
import BMWHub from "@/pages/hub/BMWHub";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/hub/bmw/")({
  head: () => routeHead("/hub/bmw/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <BMWHub />
  );
}
